import countryToCurrency from 'country-to-currency';
import callApi, { callExternalApi } from '../../util/apiCaller';

import { CATALOG_CURRENCIES } from './currencyPrices.js';

import { addError } from '../Error/ErrorActions';
import { getLocalizationRequest } from '../App/AppActions';
import { getUserPreference } from '../User/UserActions';

// Export Constants
export const SWITCH_CURRENCY = 'SWITCH_CURRENCY';
export const SET_RATES = 'SET_RATES';

export const defaultCurrency = 'EUR';
export const CURRENCY_SET_MODE = 'ip'; // 'ip' || 'intl'

export function setCurrencyRequest(newCurrency) {
    return dispatch => {
        if(newCurrency && isCurrencyEnabled(newCurrency)) {
            return callApi(`user/preference/currency/${newCurrency}`, 'post').then(res => {
                return res;
            }).catch(error => {
                // dispatch(addError(error));
            });
        }
    };
}

export function getCurrencyRatesRequest() {
    return dispatch => {
        const enabledCurrencies = getEnabledCurrencies();
        return callApi(`currencies?base=${defaultCurrency}&symbols=${enabledCurrencies.filter(currency => currency !== defaultCurrency).join(',')}`).then(res => {
            dispatch(setCurrencyRates(res.rates));
            return res;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function getEnabledCurrencies() {
    return ['EUR', ...CATALOG_CURRENCIES];
}

export function isCurrencyEnabled(currency) {
    return getEnabledCurrencies().includes(currency);
}

export function getCurrencyFromCountry(countryCode) {
	const currency = countryToCurrency[countryCode];
	return (currency && isCurrencyEnabled(currency)) ? currency : 'USD';
}

/*
 * Pays qui doit piloter la devise pendant un tunnel de commande : celui de la livraison,
 * sinon celui de la facturation. Le panier est persisté, donc le choix survit à un
 * rechargement de page. Panier vide : on laisse la géoloc décider (l'adresse conservée
 * après une commande ne doit pas figer la devise du visiteur).
 */
export function getCartCurrencyCountryCode(store) {
	const cart = (store || {}).cart || {};
	if(!(cart.items || []).length) {
		return '';
	}
	return ((cart.shipping || {}).address || {}).countryCode
		|| ((cart.invoice || {}).address || {}).countryCode
		|| '';
}

export function getCurrencySymbol(currency) {
    switch(currency) {
        case 'GBP':
            return '£';

        case 'USD':
            return '$US';

        case 'CAD':
            return '$CA';

        case 'EUR':
            return '€';

        case 'JPY':
            return '円';

        case 'KRW':
            return '원';

        default:
            return currency;
    }
}

export function initCurrency(user, mode = null) {
    return (dispatch, getState) => {
		const store = (typeof getState === 'function' && getState()) || {};

		// Le pays de livraison (ou de facturation) choisi au panier définit la devise de
		// paiement : ni la géoloc IP ni une connexion en cours de tunnel ne l'écrasent.
		const cartCountryCode = getCartCurrencyCountryCode(store);
		if(cartCountryCode) {
			return dispatch(switchCurrency(getCurrencyFromCountry(cartCountryCode), true));
		}

		// Devise déjà verrouillée par un choix explicite : on ne repasse pas sur l'IP.
		if((store.currency || {}).blockSwitch) {
			return null;
		}

        // if(user && getUserPreference(user, 'currency')) {
        //     return dispatch(switchCurrency(getUserPreference(user, 'currency')));
        // }
        // console.log(Intl.DateTimeFormat().resolvedOptions());
        let setDefaultCurrencyPromise = () => Promise.resolve({ currency: getUserPreference(user, 'currency') || defaultCurrency });
        switch(mode || CURRENCY_SET_MODE) {
            case 'ip':
                setDefaultCurrencyPromise = () => new Promise(resolve => {
                    const browserCurrency = () => getCurrencyFromTimezone(
						typeof Intl !== 'undefined' ? Intl.DateTimeFormat().resolvedOptions().timeZone : '',
					);
                    getLocalizationRequest().then(({ countryCode }) => {
                        console.log('Country', countryCode);
						if(countryCode && countryToCurrency[countryCode]) {
							let currency = countryToCurrency[countryCode];
							let block = true;
							if(!getEnabledCurrencies().includes(currency)) {
								currency = 'USD';
								block = false;
							}
							resolve({
								currency,
								block,
							});
							return;
						}
						resolve({ currency: browserCurrency() });
                    }).catch(() => {
						resolve({ currency: browserCurrency() });
					});
                });
                break;

            case 'intl':
            default: {
                setDefaultCurrencyPromise = () => Promise.resolve({ currency: getCurrencyFromTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone) || getUserPreference(user, 'currency') || defaultCurrency });
            }
        }
        return setDefaultCurrencyPromise().then(behavior => {
            return dispatch(switchCurrency(behavior.currency, behavior.block));
        });
    };
}

export function getCurrencyFromTimezone(timezone, currency = 'USD') {
    const [continent, city] = `${timezone || ''}`.toLowerCase().split('/');
    if(city === 'london') {
        currency = 'GBP';
    } else if(continent === 'canada') {
        currency = 'CAD';
    } else if(continent === 'europe' || ['martinique', 'guadeloupe', 'guyana', 'reunion'].includes(city)) {
        currency = 'EUR';
    }
    return currency;
}

export function getCurrentCurrency(store) {
    return store.currency.currency;
}

export function switchCurrency(newCurrency, blockSwitch = false) {
    if(newCurrency && isCurrencyEnabled(newCurrency)) {
        return {
            type: SWITCH_CURRENCY,
            currency: newCurrency,
			blockSwitch,
        };
    }
	return {
		type: SWITCH_CURRENCY,
		currency: defaultCurrency,
		blockSwitch: false,
	};
}

export function setCurrencyRates(rates) {
    return {
        type: SET_RATES,
        rates,
    };
}
